<aside
  class="bg-white border-r border-slate-200 h-full flex flex-col transition-all duration-200"
  [class.w-64]="open"
  [class.w-16]="!open">

  <div class="p-3">
    <p-button
      (click)="toggle()"
      [icon]="open ? 'pi pi-chevron-left' : 'pi pi-chevron-right'"
      [label]="open ? 'Ocultar' : ''"
      styleClass="w-full"
      [ngClass]="{ 'justify-center': !open }"
      aria-label="Alternar menú lateral"
    ></p-button>
  </div>

  <nav class="px-3">
    <ul class="space-y-1">
      <li *ngFor="let item of items">
        <a
          [routerLink]="item.link"
          routerLinkActive="bg-slate-100 text-primary"
          [routerLinkActiveOptions]="{ exact: item.exact ?? false }"
          class="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-slate-50 transition-colors"
          [attr.aria-label]="item.label"
        >
          <i class="{{ item.icon }} text-lg"></i>
          <span class="truncate" [class.hidden]="!open">{{ item.label }}</span>
        </a>
      </li>
    </ul>
  </nav>
</aside>
